// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_lr-5";
export var filledCircle = "_lr-4";
export var historyEntry = "_lr-3";
export var messageSideLeft = "_lr-1";
export var messageSideRight = "_lr-2";
export var orderTrackingCarouselWrapper = "_lr-6";
export var orderTrackingInfoContainer = "_lr-0";